import React from 'react';

import { Divider as ChakraDivider } from '@chakra-ui/react';

const Divider = ({ ...props }) => <ChakraDivider {...props} sx={{ borderColor: 'neutral.CFD7DF', margin: '4px 0' }} />;

export { Divider };
